module.exports = __webpack_public_path__ + "static/media/02_Citation_MKII_AR_icon_preview.acd09ba3.png";